import Service, { service } from '@ember/service';
import type Store from '@ember-data/store';
import { tracked } from '@glimmer/tracking';
import config from 'garaje/config/environment';
import type StateService from 'garaje/services/state';

const HRIS_PLUGIN_ID = config.isProduction
  ? 'cc1aacdc-079a-4ac3-bda5-cc26f64cb970'
  : '3c87c86e-8252-4a81-94d3-3588213a6021';

export default class HrisInstallService extends Service {
  @service declare store: Store;
  @service declare state: StateService;

  @tracked isInstalled = false;

  private _loadedForCompanyId: string | null = null;

  ensureLoaded(): void {
    const companyId = this.state.currentCompany?.id;
    if (!companyId || companyId === this._loadedForCompanyId) return;
    void this.load();
  }

  async load(): Promise<void> {
    const companyId = this.state.currentCompany?.id;
    if (!companyId) return;
    this._loadedForCompanyId = String(companyId);
    try {
      const installs = await this.store.query('plugin-install', {
        filter: { plugins: HRIS_PLUGIN_ID, status: 'active' },
        page: { limit: 1 },
      });
      this.isInstalled = installs.toArray().length > 0;
    } catch (err) {
      this.isInstalled = false;
      // eslint-disable-next-line no-console
      console.error('[hris-install][load] query failed:', err);
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'hris-install': HrisInstallService;
  }
}
